import { createGlobalStyle } from 'styled-components'

export const DisableBodyScroll = createGlobalStyle`
  body {
    overflow: hidden;
  }
`
